import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button,Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from 'react-hook-form';
import axios from "axios";
import { useParams } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_REST_URL;








const Resetpassword = () => {
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');

  const { token } = useParams();
  console.log("token in reset",token)
  const { control, handleSubmit, formState: { errors }, watch } = useForm({mode: "onTouched"});
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [emailverificationstatus, setEmailverificationstatus] = useState(false);
  const [candidateid, setCandidateid] = useState("");


  const isSmallScreen = useMediaQuery("(max-width:600px)");
  
  const handleNavigation=()=>{

    navigate("/signin")
  };

  const password = watch('password', '');
  const confirmPassword = watch('confirmPassword', '');

  const handleCancel = () => {
    navigate("/register");
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
  };

  // const onSubmit = async(data) => {
  //   const response = await axios.put(`${url}userEngine/updateUser`,{...data,candidate_id:candidateid})
  //   // Handle the form submission logic here
  //   console.log(data);
  //   console.log(response);
  // };
  const onSubmit = async (data) => {
    try {
      if (emailverificationstatus) {
        // Extract the password field from the data object
        const { password } = data;
  
        // Assuming candidateid is a variable in scope
        const response = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/updateUser`, {
          password,
          userId: candidateid,
        });

        if(response){
          setSuccessMessage('Your password has been reset successfully.');
        }else{
          setSuccessMessage("Not successful in sending email");

        }
  
        // Handle the form submission logic here
        console.log(data);
        console.log(response);
  
        // You can also check the response status and handle it accordingly
        if (response.status === 200) {
          // Successful update
          console.log('User updated successfully');
        } else {
          // Handle error cases
          console.error('Error updating user');
        }
      } else {
        console.log('Email verification not completed. onSubmit API call skipped.');
      }
    } catch (error) {
      // Handle any error that occurred during the API call
      console.error('An error occurred:', error.message);
    }
  };
  
  const getData = async () =>{
    try{
      const res = await axios.get(`${apiUrl}/CCE/api/v1/userEngine/resetemail_verify?verification_link=${token}`);
      console.log("response",res.data.response.userDetail.candidate_id);
      const candi = res.data.response.userDetail.candidate_id;
      const resve = res.data.response.emailVerified;
      setCandidateid(candi);
      setEmailverificationstatus(resve);
    }catch(error){
      console.error("Error:", error.message);
    }
  }
  console.log("check1",candidateid)
  console.log("check2",emailverificationstatus)
  // console.log("userwdfhf",candidateid);
  useEffect(() => {
    getData();
  },[]);
  return (
    <>
    {isSmallScreen ?(<span>
      <Box sx={styles.formboxres}>
      <Typography sx={{ fontSize: "24px", fontWeight: "bold", margin: "-12px 0px 10px 0px" }}>Forgot Password</Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ marginBottom: "-14px" }}>
          <Controller
            name="password"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label="Password"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                error={!!errors.password}
                helperText={errors.password ? errors.password.message : null}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={handleTogglePasswordVisibility}
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            rules={{
              required: 'Password is required',
              minLength: {
                value: 6,
                message: 'Password must be at least 6 characters',
              },
            }}
          />
        </Box>
        <Box sx={{ marginBottom: "4px" }}>
          <Controller
            name="confirmPassword"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label="Confirm Password"
                type={showConfirmPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword ? errors.confirmPassword.message : null}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={handleToggleConfirmPasswordVisibility}
                        aria-label="toggle confirm password visibility"
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            rules={{
              required: 'Confirm Password is required',
              validate: (value) => value === password || 'Passwords do not match',
            }}
          />
        </Box>

        <Box sx={{ textAlign: "center" }}>
          <Button onClick={handleCancel} sx={styles.cancelbtn} type="button" variant="outlined">
            Cancel
          </Button>
          <Button sx={styles.verifybtn} type="submit" variant="contained">
            Save
          </Button>
        </Box>
        {successMessage && (
        <p style={{ color: 'green' }}>
          {successMessage} Please click 
          <span
            style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={handleNavigation}
          >
            {' here '}
          </span>
          to log in to the application.
        </p>
      )}
      </form>
    </Box></span>):(<span>
      <Box sx={styles.formbox}>
      <Typography sx={{ fontSize: "24px", fontWeight: "bold", margin: "-12px 0px 10px 0px" }}>Forgot Password</Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ marginBottom: "-14px" }}>
          <Controller
            name="password"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label="Password"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                error={!!errors.password}
                helperText={errors.password ? errors.password.message : null}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={handleTogglePasswordVisibility}
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            rules={{
              required: 'Password is required',
              minLength: {
                value: 6,
                message: 'Password must be at least 6 characters',
              },
            }}
          />
        </Box>
        <Box sx={{ marginBottom: "4px" }}>
          <Controller
            name="confirmPassword"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label="Confirm Password"
                type={showConfirmPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword ? errors.confirmPassword.message : null}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={handleToggleConfirmPasswordVisibility}
                        aria-label="toggle confirm password visibility"
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            rules={{
              required: 'Confirm Password is required',
              validate: (value) => value === password || 'Passwords do not match',
            }}
          />
        </Box>

        <Box sx={{ textAlign: "center" }}>
          <Button onClick={handleCancel} sx={styles.cancelbtn} type="button" variant="outlined">
            Cancel
          </Button>
          <Button sx={styles.verifybtn} type="submit" variant="contained">
            Save
          </Button>
        </Box>
        {successMessage && (
        <p style={{ color: 'green' }}>
          {successMessage} Please click 
          <span
            style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={handleNavigation}
          >
            {' here '}
          </span>
          to log in to the application.
        </p>
      )}
      </form>
    </Box></span>)}
    </>
    
  )
}

export default Resetpassword
const styles = {
    formbox: {
      position: "absolute",
      top: "45%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "35px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "260px",
      width: "420px",
      backgroundColor: "light gray",
    },
    formboxres: {
      position: "absolute",
      top: "45%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "35px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "300px",
      backgroundColor: "light gray",
    },
    verifybtn: {
      width: "100px",
      height: "40px",
      margin: "0.25em 10px 0px 10px",
      backgroundColor: "#002C51",
      color: "white",
      textTransform: "none",
      "&:hover": {
        background: "#002C51",
      },
  
    },
    cancelbtn: {
      width: "100px",
      height: "40px",
      margin: "0.25em 10px 0px 10px",
      backgroundColor: "white",
      color: "black",
      textTransform: "none",
      "&:hover": {
        background: "white",
      },
  
    }

  };